import { ReduceStore } from 'flux/utils';
import { Map } from 'immutable';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

// Shape raw JSON into something with the attributes:
// id, name, sql, tags, and organizationId
function cleanUpQuery(query) {
  return [query.id,
    {
      id: query.id,
      ...(query.attributes),
      organizationId: +query.relationships.organization.data.id,
    }];
}

// Action to take on stores, listening for CrossChannel.SOURCE_TABLES_RECEIVED
class QueryStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  // On the event CrossChannel.SOURCE_TABLES_RECEIVED,
  // filter responses thru the cleanUpQuery method
  reduce(state, action) {
    switch (action.actionType) {
      case Constants.CrossChannel.SOURCE_TABLES_RECEIVED:
        return this.getState().merge(new Map(action.queries.map(cleanUpQuery)));
      default:
        return state;
    }
  }

  // given a tag, filter down to just tags on that endpoint and org id
  // probably will eventually move to util
  getTaggedQueriesForOrganization(tag, organizationId) {
    return this.getState().filter(query => query.organizationId === organizationId &&
                                           query.tags.indexOf(tag) > -1);
  }

  getQuery(id) {
    return this.getState().find(query => query.id === id);
  }
}

const instance = new QueryStore(AppDispatcher);
export default instance;
